import { useState, useEffect } from 'react';

export function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div data-testid="offline-banner" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 10000,
      background: '#D4321C',
      color: '#fff',
      textAlign: 'center',
      padding: '10px 16px',
      fontSize: 13,
      fontFamily: 'Jost, sans-serif',
      fontWeight: 500,
      letterSpacing: 0.5,
    }}>
      You are offline. Some features may not work until you reconnect.
    </div>
  );
}
